import {
  AppBar,
  createStyles,
  makeStyles,
  Theme,
  Toolbar,
  Typography,
} from '@material-ui/core'
import { useAuth0 } from '@auth0/auth0-react'
import UserMenu from './userMenu'
import { SideBar } from './sideBar'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    appBar: {
      gap: 10,
    },
    title: {
      ...theme.typography.h6,
      color: 'white',
      fontFamily: 'Montserrat',
      fontWeight: 'bold',
      flexGrow: 1,
    },
    username: {
      color: 'white',
    },
  }),
)

export const TopBar = (): JSX.Element => {
  const { user } = useAuth0()

  const classes = useStyles()
  return (
    <AppBar position='static'>
      <Toolbar className={classes.appBar}>
        <SideBar />
        <div className={classes.title}>MTV</div>
        <Typography className={classes.username}>{user!.name}</Typography>
        <UserMenu />
      </Toolbar>
    </AppBar>
  )
}
